import { render } from "./IconTrash.vue?vue&type=template&id=4f5ba34f&scoped=true"
import script from "./IconTrash.vue?vue&type=script&lang=js"
export * from "./IconTrash.vue?vue&type=script&lang=js"

import "./IconTrash.vue?vue&type=style&index=0&id=4f5ba34f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5ba34f"]])

export default __exports__